import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { openBookingModal } from "../lib/bookingModal";

export default function Footer() {
  return (
    <footer className="relative bg-[#0B192C] text-white/80 grain overflow-hidden" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-20 grid md:grid-cols-4 gap-12 relative z-10">
        <div className="md:col-span-2">
          <h3 className="font-serif text-4xl text-white mb-3">Byer Fountain Motor Inn</h3>
          <p className="max-w-md font-light leading-relaxed">
            Comfort beyond expectations — genuine country hospitality in the heart of Holbrook, the halfway
            haven between Sydney and Melbourne.
          </p>
          <button onClick={() => openBookingModal()} data-testid="footer-book"
            className="mt-6 bg-[#D4AF37] text-[#0B192C] px-6 py-3 rounded-full font-medium hover:bg-white transition-colors">
            Book Direct — Best Rate
          </button>
        </div>
        <div>
          <h4 className="overline text-[#D4AF37] mb-5">Explore</h4>
          <ul className="space-y-3 text-sm">
            {[["Rooms","/rooms"],["Corporate","/corporate"],["Restaurant","/dining"],["Visit Holbrook","/visit-holbrook"],["Gallery","/gallery"],["Contact","/contact"]].map(([l,t]) => (
              <li key={t}><Link to={t} className="hover:text-[#D4AF37] transition-colors">{l}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="overline text-[#D4AF37] mb-5">Visit Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-3"><MapPin size={16} className="text-[#D4AF37] shrink-0" /> 164 Albury Street, Holbrook NSW 2644</li>
            <li className="flex gap-3"><Phone size={16} className="text-[#D4AF37] shrink-0" /> <a href="tel:0260362077" className="hover:text-[#D4AF37]">02 6036 2077</a></li>
            <li className="flex gap-3"><Mail size={16} className="text-[#D4AF37] shrink-0" /> <a href="mailto:admin@byerfountainmotorinn.com.au" className="hover:text-[#D4AF37] break-all">admin@byerfountainmotorinn.com.au</a></li>
          </ul>
          <div className="mt-5">
            <h4 className="overline text-[#D4AF37] mb-2">Reception Hours</h4>
            <p className="text-sm">Mon–Fri: 9:00 AM – 9:00 PM<br/>Sat–Sun: 10:00 AM – 8:00 PM</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40 relative z-10">
        © {new Date().getFullYear()} Byer Fountain Motor Inn · Check-in 1:00 PM · Check-out 10:00 AM · Holbrook NSW
      </div>
    </footer>
  );
}
